module.exports = __webpack_public_path__ + "img/yl3021.3519cf41.png";